import FormBiblio from './FormBiblio.js';
import PropTypes from 'prop-types';

const AppBiblio = ({ listLocalisationBiblio }) => (
  <FormBiblio listLocalisationBiblio={listLocalisationBiblio} />
);

AppBiblio.propTypes = {
  listLocalisationBiblio: PropTypes.object.isRequired,
};

export default AppBiblio;
